/**
 * Hero viewport offset: sets --viewport-top-offset only (never --header-height).
 *
 * --header-height is owned by the header section (sections/header.liquid) and is used by:
 *   - base.css: .header { min-height: var(--header-height) }
 *   - section-blog-post.css: sticky top
 *   - section-product-slider.css: padding-top
 * Do not set --header-height in this file.
 *
 * This script measures the distance from document top to the first [data-measure-viewport-top]
 * and sets --viewport-top-offset so hero sections can use calc(100vh - var(--viewport-top-offset)).
 * When no hero is on the page, sets --viewport-top-offset to the current --header-height.
 */
(function () {
	function setViewportTopOffset() {
		var el = document.querySelector('[data-measure-viewport-top="true"]');
		var valuePx;
		if (el) {
			var rect = el.getBoundingClientRect();
			var scrollY = window.pageYOffset !== undefined ? window.pageYOffset : window.scrollY;
			valuePx = Math.max(0, Math.round(rect.top + scrollY));
		} else {
			var root = document.documentElement;
			var current = getComputedStyle(root).getPropertyValue('--header-height').trim();
			valuePx = (current && current.length > 0) ? current : '0px';
		}
		var value = typeof valuePx === 'number' ? valuePx + 'px' : valuePx;
		document.documentElement.style.setProperty('--viewport-top-offset', value);
	}

	function run() {
		setViewportTopOffset();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', run);
	} else {
		run();
	}
	window.addEventListener('resize', setViewportTopOffset);
	window.addEventListener('load', run);
	document.addEventListener('shopify:section:load', run);
})();
